module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_29.27d2cf91.png";